// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MyQS","rootMobile":"styles_rootMobile__3zG1r"};